import type { SubscriptionTier } from '@heidi/schema/ml-scribe';
import { atom } from 'jotai';

import type { TrackTeamTrialUpgradeRequestSubmit } from '../../../contracts/team-trial-upgrade-request-analytics.types';

export type TeamTrialUpgradeRequestPlan =
  | SubscriptionTier.CLINICIAN_PRO
  | SubscriptionTier.CLINICIAN_PRO_PLUS;

export type TeamTrialUpgradeRequestModalAtomValue =
  | { isOpen: false }
  | {
      isOpen: true;
      plan: TeamTrialUpgradeRequestPlan;
      /**
       * The submit emit, bound by whoever opened the modal.
       *
       * NOT a `ScreenName`, because the submit reports the ORIGIN's screen
       * rather than the modal's own — and the modal is opened
       * from seven places, four of them in other roots (billing, the clinician
       * upgrade modal, Chat's credits popover). The screen was therefore never
       * this surface's to name; the emitter is, so it crosses as a port from
       * `src/models/analytics/features/trackTeamTrialUpgradeRequestAnalytics.ts`
       * alongside the two callbacks already here (ruling 24).
       */
      trackRequestSubmitted: TrackTeamTrialUpgradeRequestSubmit;
      onRequestSent?: () => void;
      onUserDismiss?: () => void;
    };

export const teamTrialUpgradeRequestModalAtom =
  atom<TeamTrialUpgradeRequestModalAtomValue>({
    isOpen: false,
  });

type OpenPayload = Omit<
  Extract<TeamTrialUpgradeRequestModalAtomValue, { isOpen: true }>,
  'isOpen'
>;

/** Set by callers to open the globally mounted {@link TeamTrialUpgradeRequestModal}. */
export const openTeamTrialUpgradeRequestModalAtom = atom(
  null,
  (_get, set, payload: OpenPayload) => {
    set(teamTrialUpgradeRequestModalAtom, { isOpen: true, ...payload });
  }
);

export const closeTeamTrialUpgradeRequestModalAtom = atom(null, (_get, set) => {
  set(teamTrialUpgradeRequestModalAtom, { isOpen: false });
});
